import React from 'react';
import TeaCupMarketing from './TeaCupMarketing';

const TeaShopBoards = () => <TeaCupMarketing mode="tea-shop-boards" />;

export default TeaShopBoards;
